import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getResidueList as getResidueListApi,
	getResidue as getResidueApi,
	addNewResidue as addNewResidueApi,
	updateResidue as updateResidueApi,
	deleteResidue as deleteResidueApi
} from '../../helpers/residue/backend_helper';

export const getResidueList = createAsyncThunk('residues/getResidueList', async (params) => {
	try {
		const response = getResidueListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getResidue = createAsyncThunk('residues/getResidue', async residue_id => {
	try {
		const response = getResidueApi(residue_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewResidue = createAsyncThunk('residues/addNewResidue', async residue => {
	try {
		const response = addNewResidueApi(residue);
		toast.success('Residue agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar residue.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateResidue = createAsyncThunk('residues/updateResidue', async (residue) => {
		try {
			const response = updateResidueApi(residue);
			toast.success('Residue actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar residue.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteResidue = createAsyncThunk('residues/deleteResidue', async residue => {
	try {
		const response = await deleteResidueApi(residue);
		toast.success('Residue eliminado exitosamente.', { autoClose: 3000 });
		return { residue, ...response };
	} catch (error) {
		toast.error('Error al eliminar residue.', { autoClose: 3000 });
		throw new Error(error);
	}
});
